export default {
  pagesGameClassify: {
    sureDeleteClassify: 'Xác nhận xóa phân loại trò chơi chứ?',
    sureDeleteGameClassify: 'Xác nhận xóa các phân loại trò chơi đã chọn chứ?',
    sureDeleteClassifyStatus: 'Xác nhận thay đổi trạng thái phân loại trò chơi chứ?',
    selectDeleteOption: 'Chọn các mục cần xóa',
    name: 'Tên loại trò chơi',
    status: 'Trạng thái hoạt động',
    name1: 'loại',
    name2: 'thao tác',
    errorClassifyName: 'Điền tên loại trò chơi',
    errorPlaceholderSort: 'Điền số thứ tự'
  },
  pagesGameManage: {
    sureUseGame: 'Xác nhận mở trò chơi này',
    sureNotUserGame: 'Xác nhận đóng trò chơi này',
    game: 'trò chơi',
    platform: 'nền tảng bạn thuộc về',
    gameIcon: 'hình ảnh',
    gameClassify: 'phân loại trò chơi',
    gameName: 'tên trò chơi',
    gameCode: 'mã trò chơi',
    pumping: 'Hoa hồng tiền thưởng',
    back: 'Hoàn trả',
    maxBack: 'chiết khấu tối đa',
    minBack: 'chiết khấu tối thiểu',
    error1: 'Chọn phân loại trò chơi',
    error2: 'Điền tên trò chơi）',
    error3: 'Điền mã trò chơi',
    error4: 'Điền chiết khấu tiền thưởng',
    error5: 'Chiết khẩu tiền thưởng phải lớn hơn hoặc bằng 0',
    error6: 'Điền số hoàn trả tối thiểu',
    error7: 'Hoàn trả tối thiểu phải lớn hơn hoặc bằng 0',
    error8: 'Hoàn trả tối thiểu không được vượt quá hoàn trả tối đa',
    error9: 'Điền số hoàn trả tối đa',
    error10: 'Hoàn trả tối đa phải lớn hơn hoặc bằng 0',
    error11: 'Hoàn trả tối đa không được nhỏ hơn hoàn trả tối thiểu',
    error12: 'Điền số thứ tự',
    error13: 'Tải lên icon trò chơi',
    error14: 'Điền số tiền thưởng ban đầu',
    error15: 'Vui lòng nhập một số nguyên',
    error16: 'Điền số phần trăm dự thưởng',
    error17: 'Điền 1-100,tối đa 2 chữ số thập phân',
    error18: 'Điền chiết khấu khuyến mãi',
    error19: 'Vui lòng chọn nhà cái',
    error20: 'Vui lòng chọn trò chơi',
    error21: 'Vui lòng chọn một người dùng',
    title1: 'Số lượng cược tối đa',
    title2: 'tên trò chơi',
    title3: 'Số tiền hũ thưởng ban đầu',
    title4: 'số tiền đặt cược',
    title5: 'Số tiền hũ thưởng ban đầu(Gold)',
    title6: 'Tỷ lệ vào thưởng',
    title7: 'Số tiền hũ thưởng ban đầu(Silver)',
    title8: 'hoa hồng khuyến mãi',
    title9: 'cài đặt hoàn trả',
    title10: 'Cấu hình tham số RTP',
    title11: 'RTP Thực tế',
    title12: 'RTP Chơi Thường',
    title13: 'RTP Chơi Đặc Biệt',
    remark: 'Tỉ lệ phần trăm lợi nhuận mà hệ thống đưa vào giải thưởng cho mỗi kỳ của trò chơi',
    quick: 'Các phím tắt',
    placeholderGame: 'Vui lòng chọn trò chơi',
    placeholderAddMember: 'Thêm người dùng',
    placeholderRemark: 'ghi chú'
  },
  pagesGameFishManage: {
    title1: 'Biểu tượng cấp độ',
    title2: 'tên cấp độ',
    title3: 'Tỷ lệ cược tối thiểu',
    title4: 'Tỷ lệ cược tối đa',
    title5: 'Xác suất diệt tối thiểu',
    title6: 'Xác suất diệt tối đa',
    title7: 'vòng đời',
    title8: 'có phải là cá đặc biệt',
    title9: 'Khoảng thời gian tối thiểu',
    title10: 'tỷ lệ cược',
    title11: 'Tỷ lệ cược tối thiểu',
    title12: 'Tỷ lệ cược tối đa',
    title13: 'xác suất diệt',
    title14: 'Xác suất diệt tối thiểu',
    title15: 'Xác suất diệt tối đa',
    title16: 'thời gian',
    title17: 'loại hình',
    title18: 'Khoảng thời gian tối thiểu',
    title19: 'hình ảnh',
    title20: 'tên cách chơi',
    statusYes: 'có',
    statusNo: 'không',
    error1: 'Điền tên của loại cá',
    error2: 'Tên loại cá không được quá 20 ký tự',
    error3: 'Điền tỉ lệ cược tối thiểu',
    error4: 'Tỉ lệ cược tối thiểu vượt quá giới hạn',
    error5: 'Tỉ lệ cược tối thiểu là các số dương có tối đa 2 chữ số thập phân',
    error6: 'Tỉ lệ cược tối thiểu không được vượt quá tỉ lệ cược tối đa',
    error7: 'Điền tỉ lệ cược tối đa',
    error8: 'Tỉ lệ cược tối đa vượt quá giới hạn',
    error9: 'Tỉ lệ cược tối đa là các số dương có tối đa 2 chữ số thập phân',
    error10: 'Tỉ lệ cược tối đa không được nhỏ hơn tỉ lệ cược tối thiểu',
    error11: 'Điền điểm giết tối thiểu',
    error12: 'Điểm giết tối thiểu là một số nguyên dương',
    error13: 'Điểm giết tối thiểu không được lớn hơn điểm giết tối đa',
    error14: 'Điền điểm giết tối đa',
    error15: 'Điểm giết tối đa là một số nguyên dương',
    error16: 'Điểm giết tối đa không được nhỏ hơn điểm giết tối thiểu',
    error17: 'Điền chu kỳ sinh tồn',
    error18: 'Chu kỳ sinh tồn là một số nguyên dương',
    error19: 'Điền khoảng cách tối thiểu của đường đi',
    error20: 'Khoảng cách tối thiểu của đường đi là một số nguyên dương',
    error21: 'Tải hình ảnh lên',
  },
  pagesGameRobotData: {
    title1: 'đặt cược thắng thua',
    title2: 'nền tảng bạn thuộc về',
    title3: 'Thống kê thời gian',
    title4: 'trò chơi',
    title5: 'số tiền cược',
    title6: 'tiền cược',
    title7: 'thao tác',
    title8: 'Chi tiết tham gia',
    title9: 'đặt cược',
    title10: 'ID robot',
    title11: 'thời gian',
    title12: 'đặt cược',
    title13: 'Số lượng robot',
    title14: 'Tên robot',
    title15: 'Số lần tham gia',
    title16: 'Số lần cược (Số đơn)',
    title17: 'hôm nay',
    title18: 'Hôm qua',
    title19: '7 ngày gần đây',
    title20: '30 ngày gần đây',
    title21: '90 ngày gần đây',
  },
  pagesGameOdds: {
    name1: 'phân loại trò chơi',
    name2: 'nhóm người dùng',
    name3: 'Tên cách chơi',
    name4: 'Cài đặt tỷ lệ cược',
    name5: 'thao tác',
    name6: 'trò chơi',
    name7: 'Số tiền cược cao nhất trong kỳ'
  },
  pagesGameBlack: {
    name1: 'tên trò chơi',
    name2: 'người thao tác',
    name3: 'nền tảng bạn thuộc về',
    name4: 'ghi chú từ điển',
    name5: 'thời gian nhật ký',
    name6: 'thao tác',
    name7: 'trò chơi',
    message1: 'Chọn mục danh sách đen cần hủy',
    message2: 'Thêm danh sách đen thành công',
    message3: 'Xác nhận hủy danh sách đen chứ'
  },
  gameJackPotDatas: {
    gameName: "Trò chơi",
    activityName: "Khuyến mãi",
    initPrizePoolAmount: "Số tiền thưởng ban đầu",
    botAddAmount: "Tiền bỏ vào hũ từ robot",
    userAddAmount: "Tiền bỏ vào hũ từ người chơi",
    totalAmount: "Số tiền Jackpot hiện tại",
    option: "Thao tác",
    platformCode: "Tất cả nền tảng",
    issue: "Kỳ",
    botBetAmount: "Số tiền cược của robot",
    botPrizePoolAmount: "Tiền thưởng--Robot",
    userBetAmount: "Số tiền cược của người chơi",
    userPrizePoolAmount: "Tiền thưởng Jackpot--Người chơi",
    prizePoolAddAmount: "Tiền thưởng Jackpot--Số tiền thêm vào",
    totalPrizePoolAmount: "Tiền thưởng Jackpot--Tổng số tiền",
    bombIssue: "Kỳ nổ hũ",
    prizeNum: "Số mở thưởng",
    prizePoolAmount: "Tiền thưởng Jackpot",
    initPrizePoolAmount1: "Tiền thưởng Jackpot--Ban đầu",
    userPrizeCount: "Số người chơi trúng thưởng",
    userPrizeTotal: "Tổng số tiền trúng thưởng",
    userPrizeInfo: "Chi tiết trúng thưởng",
    prizePoolAmountInfo: "Chi tiết tiền thưởng Jackpot",
    account: "Tên tài khoản",
    betAmount: "Số tiền cược nhận thưởng",
    prizeAmount: "Số tiền nhận thưởng",
    activityPumping: "Chiết khấu khuyến mãi",
    filterBot: "Lọc robot",
    botFlag: "Robot",
    botFlag0: "Có",
    botFlag1: "Không",
    historyTitle: "Lịch sử cược"
  }
}
